import { PropsWithChildren } from 'react';

import { cn } from '@/utils/classname';

/**
 * This component is used to represent a flex row
 * @param param0
 * @returns
 */
export const Row = ({
  className = '',
  dataTestId,
  children,
}: { className?: string; dataTestId?: string } & PropsWithChildren) => (
  <div
    data-testid={dataTestId}
    className={cn('flex items-center gap-2 pb-4', className)}
  >
    {children}
  </div>
);
